import { login, logout, getUserInfo } from "@/api/user";
import { setToken, getToken, setStorage, getStorage } from "@/libs/util";
import config from "@/config";

export default {
  state: {
    userName: "",
    userId: 0,
    departId: 0,
    avatorImgPath: "",
    modulePermission: [],
    menuPermission: [],
    token: getToken()
  },
  mutations: {
    setAvator(state, avatorPath) {
      state.avatorImgPath = avatorPath;
    },
    setUserId(state, id) {
      state.userId = id;
    },
    setDepartId(state, id) {
      state.departId = id;
    },
    setUserName(state, name) {
      state.userName = name;
    },
    setToken(state, token) {
      state.token = token;
      setToken(token);
    },

    setMenuPermission(state, list) {
      state.menuPermission = list;
    },
    setModulePermissioin(state, list) {
      state.modulePermission = list;
    }
  },
  getters: {
    access: state => {
      return state.access;
    }
  },
  actions: {
    // 登录
    handleLogin({ commit }, { userName, password }) {
      userName = userName.trim();
      return new Promise((resolve, reject) => {
        login({
          userName,
          password
        })
          .then(res => {
            setStorage("emshop", JSON.stringify(res.data));
            commit("setAvator", res.data.avator);
            commit("setUserName", res.data.username);
            commit("setUserId", res.data.userid);

            commit("setToken", res.data.access_token);
            commit("setMenuPermission", res.data.menuPermission);
            commit("setModulePermissioin", res.data.modulePermission);
            resolve(res);
          })
          .catch(err => {
            alert("登录失败,账号或密码错误");
            reject(err);
          });
      });
    },
    // 退出登录
    handleLogOut({ state, commit }) {
      return new Promise((resolve, reject) => {
        logout(state.token)
          .then(() => {
            commit("setUserId", 0);
            commit("setToken", "");
            commit("setUserName", "");
            resolve();
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    // 获取用户相关信息
    getUserInfo({ state, commit }) {
      return new Promise((resolve, reject) => {
        try {
          getUserInfo(state.token)
            .then(res => {
              commit("setAvator", res.data.avator);
              commit("setUserName", res.data.username);
              commit("setUserId", res.data.userid);
              commit("setToken", res.data.access_token);
              commit("setMenuPermission", res.data.menuPermission);
              commit("setModulePermissioin", res.data.ModulePermission);
              resolve(res.data);
            })
            .catch(err => {
              reject(err);
            });
        } catch (error) {
          reject(error);
        }
      });
    },
    reloadLoginData({ state, commit }) {
      let emshop = getStorage("emshop");
      if (typeof emshop !== "undefined") {
        let data = JSON.parse(emshop);

        commit("setAvator", data.avator);
        commit("setUserName", data.username);
        commit("setUserId", data.userid);
        commit("setToken", data.access_token);
        commit("setMenuPermission", data.menuPermission);
        commit("setModulePermissioin", data.modulePermission);
      }
    }
  }
};
